import ReactOnRails from 'react-on-rails/client';
import App from '../../components/App/ror_components/App.client.jsx';

ReactOnRails.register({App});